module.exports = __webpack_public_path__ + "VIPM6.png?30ebe771328194eb8ecc18cb46cf2401";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/motorracing/VIPM6.png
// module id = 151
// module chunks = 0